import { SearchActionType } from "models/actionTypes/searchActionTypes";
import { ContextConstants } from "utils/constants";
import { SearchContextState } from "models/propTypes/reportsPropTypes";

export const SearchReducer = (state: SearchContextState, action: SearchActionType) => {
  switch (action.type) {
    case ContextConstants.SearchActions.SET_SEARCH_TEXT: {
      return { ...state, searchText: action.payload };
    }
    default:
      return state;
  }
};
